import * as R from 'unitx/ramda';
import { dark as NativeDarkTheme } from '@eva-design/eva';
export const DarkTheme = R.mergeDeepRight(NativeDarkTheme, {
  colors: {
    primary: 'rgb(155,201,245)',
    secondary: 'rgb(230,148,176)',
    error: 'rgb(225,82,65)',
    warning: 'rgb(242,156,56)',
    info: 'rgb(71,150,236)',
    success: 'rgb(103,172,91)',
    text: 'rgb(255,255,255)',
    placeholder: 'rgb(189,189,189)',
    disabled: 'rgb(144,144,144)',
    background: '#121212',
    surface: '#121212',
    backdrop: 'rgb(0, 0, 0, 0.5)'
  }
});